import React, { useEffect, useState } from 'react'
import styles from './ClientDetails.module.css'
import './ClientDetails.module.css'
import Otp from '../../components/Otp/Otp'
import SearchIcon from '../../assets/search-icon.png'
// import YearIcon from '../../assets/year-icon.png'
import { useLocation, useNavigate } from 'react-router-dom'
// import YearPicker from '../../components/YearPicker/YearPicker'
import { prpHttpAPI } from '../../services/prpHttpAPI'
import PageTracker from '../../components/PageTracker/PageTracker'

const ClientDetails = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const path = queryParams.get("path");
  const [loading, setLoading] = useState(false);
  const [spoc_or_admin, setSpoc_or_admin] = useState(false);
  const [nameRequired, setNameRequired] = useState(false);

  const [ageRequired, setAgeRequired] = useState(false);
  const [lifeExpectRequired, setLifeExpectRequired] = useState(false);
  const [expenseRequired, setExpenseRequired] = useState(false);
  const [incomeRequired, setIncomeRequired] = useState(false);
  const [yorRequired, setYorRequired] = useState(false);
  const [isClientExist, setIsClientExist] = useState(false);
  const [clientName, setClientName] = useState("");
  const [userReturningFlag, setUserReturningFlag] = useState(false);
  const [clientError, setClientError] = useState("");
  const [disableRm, setDisableRm] = useState(false);


  const [searchAPICall, setSearchAPICall] = useState(false);
  const [nextDisable, setNextDisable] = useState(true);
  const [pan, setPan] = useState("");
  const [panRequired, setPanRequired] = useState(false);
  const [panError, setPanError] = useState("");
  const [noPanLength, setNoPanLength] = useState(false);
  const [rm, setRm] = useState("");
  const [rmRequired, setRmRequired] = useState(false);
  const [rMMessage, setRMMessage] = useState("");

  const [phoneRequired, setPhoneRequired] = useState(false);
  const [phone, setPhone] = useState("")
  const [phoneError, setPhoneError] = useState("");

  const [clientEmail, setClientEmail] = useState("");
  const [clientEmailRequired, setClientEmailRequired] = useState(false);
  const [clientEmailError, setClientEmailError] = useState("");

  const [assignPlan, setAssignPlan] = useState("");
  const [assignPlanRequired, setAssignPlanRequired] = useState(false);
  const [assignPlanError, setassignPlanError] = useState("");

  const [rmError, setRmError] = useState("");
  const [age, setAge] = useState("");
  const [error, setError] = useState("");
  const [lifeExpectValue, setLifeExpectValue] = useState("")
  const [lifeExpectError, setLifeExpectError] = useState("");
  const [expenseValue, setExpenseValue] = useState("");
  const [incomeValue, setIncomeValue] = useState("");
  const [numericExpenseValue, setNumericExpenseValue] = useState(null);
  const [numericIncomeValue, setNumericIncomeValue] = useState(null);
  const [expenseError, setExpenseError] = useState("");
  const [incomeError, setIncomeError] = useState("");
  const [progressValue, setProgressValue] = useState(5); // Initial value at 12%
  const [YoR, setYoR] = useState("")
  const [yorError, setYorError] = useState("")
  const [plan_id, setPlan_id] = useState("");
  const [showAssignPlan, setShowAssignPlan] = useState(false); // or true by default
  const [familyMembers, setFamilyMembers] = useState([]);    // updatedd
  const [incomeGrowthRate, setIncomeGrowthRate] = useState("7% — Moderate");   //updatedd

  const rmInfo = JSON.parse(localStorage.getItem('rm_info')) ?? { BRANCH_NAME: '' };



  const [client, setClient] = useState({
    client_name: "",
    phone_number: "",
    pan: "",
    spoc_rm: "",
    age: "",
    life_expectancy: "",
    monthly_expenses: "",
    annual_income: "",
    year_of_retirement: "",
    inflation_rate: progressValue,
    category_id: "",
    client_email: "",
    assign_plan: "",
    family_members: [],  //updatedd
    income_growth_rate: 6,  //updatedd

  });
  const [showModal, setShowModal] = useState(false);

  let localtoken;
  // token authentication 
  const checkToken = () => {

    localtoken = localStorage?.getItem("ssotoken");
    // const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const ssotoken = queryParams.get('ssotoken');
    if (localtoken) {
      console.log('User logged in');
    }
    else {
      console.log('token not found');
      // Redirect to a different URL
      window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`;

      //  navigate('');
    }
  }
  useEffect(() => {
    checkToken();
    if (localStorage?.getItem('actionType')) {
      const error = localStorage?.getItem('actionType')
      window.toastr.error(error, 'Error', {
        closeButton: true,
        positionClass: 'toast-top-right',
        // timeOut: 5000, // Auto-close after 5 seconds
      });
    }
    const allowedRmCodes = ['127600', '127600', '38828', '127229', '141914', '112703', '43286', '146766'];
    const bCode = localStorage?.getItem('bCode')
    const joinOnRmCode = allowedRmCodes.includes(bCode);
    if (localStorage?.getItem('isAdmin') == 1 || joinOnRmCode) {
      setSpoc_or_admin(true);
    }
    // if(localStorage.getItem('payroll_id'))
    // setRm(localStorage.getItem('payroll_id'));
  }, [])

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup in case of component unmount
    };
  }, [showModal]);

  //onRefreshOnly
  useEffect(() => {
    const handleRefresh = () => {
      localStorage.removeItem('userData');
      localStorage.removeItem('clientInvestmentData');
      localStorage.removeItem("actionType");

    };

    window.addEventListener('beforeunload', handleRefresh);

    return () => {
      window.removeEventListener('beforeunload', handleRefresh);
    };
  }, []);
  //toRetainClientDetails - on clicking back button in clientInvestments
  useEffect(() => {
    localStorage.removeItem("versions");
    localStorage.removeItem("planCompletedFlag");
    const savedData = localStorage?.getItem('userData');
    if (savedData) {
      const userData = JSON.parse(savedData);

      setClientName(userData.client_name || "");
      setPhone(userData.phone_number ?? "");
      setClientEmail(userData.client_email || userData.email_id || "");
      setPan(userData.pan_number ?? "");               // Fix — was null
      setRm(userData.spoc_rm ?? "");                   // Fix — was null
      setAssignPlan(userData.assign_plan ?? "");        // Fix — was null

      if (userData.pan_number == null) {
        setNoPanLength(true);
      }

      setAge(userData.age.toString());
      setError("");
      setYoR(userData.year_of_retirement.toString());
      setYorError("");
      setLifeExpectValue(userData.life_expectancy.toString());
      setLifeExpectError("");
      setExpenseValue(Intl.NumberFormat("en-IN").format(userData.monthly_expenses ?? ""));
      setNumericExpenseValue(userData.monthly_expenses ?? "");
      setIncomeValue(Intl.NumberFormat("en-IN").format(userData.annual_income ?? ""));
      setNumericIncomeValue(userData.annual_income ?? "");
      setPlan_id(userData.plan_id ?? "");
      setUserReturningFlag(!!userData.client_name);
      // Restore inflation rate — remove the old setProgressValue(userData.inflation_rate) line
      const inflationMap = {
        3: "3% — Conservative",
        4: "4%",
        5: "5% — Moderate",
        6: "6% — Standard",
        7: "7% — Aggressive",
        8: "8% — High",
        9: "9%",
        10: "10% — Very High",
      };
      setProgressValue(inflationMap[userData.inflation_rate] ?? "6% — Standard");

      // Restore income growth rate
      const rateMap = {
        0: "0% — Fixed Income",
        1: "1%", 2: "2%", 3: "3%", 4: "4%",
        5: "5%", 6: "6%", 7: "7%", 8: "8%",
        9: "9%", 10: "10%", 11: "11%", 12: "12%",
        13: "13%", 14: "14%", 15: "15%",
      };
      setIncomeGrowthRate(rateMap[userData.annual_growth_rate] ?? "7%");

      if (Array.isArray(userData.family_members) && userData.family_members.length > 0) {
        setFamilyMembers(userData.family_members);
      }

      setNextDisable(false);
    }
  }, [searchAPICall]);
  //////////////////////


  useEffect(() => {
    //  Your condition here
    // Example: Show field only if clientEmail has a certain value or is empty
    let rm_info = localStorage.getItem('rm_info');
    rm_info = JSON.parse(rm_info);

    console.log('--------', rm_info.BRANCH_NAME);

    if (rm_info.BRANCH_NAME.includes('swat') || rm_info.BRANCH_NAME.includes('SWAT')) {
      setShowAssignPlan(true);
    } else {
      setShowAssignPlan(false);
      setAssignPlan("");
    }
  }, []);


  //////////////////////

  const handleClientNameChange = (e) => {
    const value = e.target.value;

    // Allow only alphabetic characters and limit to 20 characters

    if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 20) {

      setClientName(value);
      setNameRequired(false);
      setClientError('')
    }
  };
  const handlePhoneChange = (event) => {
    let value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    // Prevent typing if the first digit is not 6, 7, 8, or 9
    if (value.length > 0 && !/^[6789]/.test(value)) {
      setPhoneError("Phone number must start with 6, 7, 8, or 9");
      return; // Stop further execution
    }

    setPhoneError(""); // Clear error when valid

    // Allow input only if length is 10 or less
    if (value.length <= 10) {
      setPhone(value);
    }

    // Validate length
    if (value.length > 1 && value.length !== 10) {
      setPhoneError("Phone number should be 10 digits");
      setPhoneRequired(false);
    } else if (value.length === 10) {
      setPhoneError("");
    }
  };
  //phone blur 
  const handlePhoneBlur = async (event) => {
    let value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    // Prevent typing if the first digit is not 6, 7, 8, or 9
    if (value.length > 0 && !/^[6789]/.test(value)) {
      return; // Stop further execution
    }
    if (value.length == 10) {
      let data = { phone_number: value };
      console.log("data", data);

      const localtoken = localStorage?.getItem("ssotoken");
      setLoading(true);
      const result = await prpHttpAPI(data, "search", localtoken, "POST", 'client-details');
      setLoading(false);
      if (result) {
        console.log("result in search client", result);
        setNextDisable(false);
        if (result.action === "different_rm") {
          setRMMessage(result.msg);
          console.log("client with different rm");
          window.toastr.error(result.msg, 'Error', {
            closeButton: true,
            positionClass: 'toast-top-right',
            // timeOut: 5000, // Auto-close after 5 seconds
          });
          return;
        } else {
          setRMMessage('');
        }

        if (result.success == true && result.action == 'plan') {
          window.toastr.warning(result.msg, 'Warning', {
            closeButton: true,
            positionClass: 'toast-top-right',
            // timeOut: 5000, // Auto-close after 5 seconds
          });
          let clients = result.data.planDetails;
          let investments = result.data.investmentDetails;
          localStorage.setItem('userData', JSON.stringify(clients[clients.length - 1]));
          if (investments && investments.length > 0) {
            localStorage.setItem('clientInvestmentData', JSON.stringify(investments[investments.length - 1]));
          }
          setSearchAPICall(true);
        }
      }
    }
  }
  //pan
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // PAN Validation Regex
  const handlePanChange = (event) => {
    const value = event.target.value.toUpperCase(); // Convert to uppercase
    setPan(value);


    let rm_info = localStorage.getItem('rm_info');
    rm_info = JSON.parse(rm_info);

    if (!(rm_info.BRANCH_NAME.includes('swat') || rm_info.BRANCH_NAME.includes('SWAT') || rm_info.BRANCH_NAME.includes('VIS - NORTH'))) {
      if (value == '') {
        setPanRequired(true);
        setPanError("PAN number mandotry");;
      }
    }
    else {
      setPanRequired(false);
    }




    if (!panRegex.test(value) && value !== "") {
      setPanError("Invalid PAN format (e.g., ABCDE1234F)");
      setPanRequired(true);
    } else {
      setPanError("");
      setPanRequired(false);
    }
  };


  const handleAddFamilyMember = () => {                                                       //updatedd
    setFamilyMembers([...familyMembers, { name: "", relationship: "Spouse", pan: "" }]);
  };

  const handleFamilyMemberChange = (index, field, value) => {                                 //updatedd
    const updatedMembers = [...familyMembers];
    updatedMembers[index][field] = field === 'pan' ? value.toUpperCase() : value;
    setFamilyMembers(updatedMembers);
  };

  const handleRemoveFamilyMember = (index) => {                                               //updatedd
    const updatedMembers = familyMembers.filter((_, i) => i !== index);
    setFamilyMembers(updatedMembers);
  };


  //rm
  //pan
  const handleRmChange = (event) => {
    let value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters


    setRmError(""); // Clear error when valid

    // Allow input only if length is 6 or less\
    // Allow empty value (for backspace)
    if (value === "" || (/^[1-9]\d{0,5}$/.test(value))) {
      setRm(value);
    }

    // Validate length
    if (value.length >= 1 && value.length !== 5 && value.length !== 6) {
      setRmError("RM code should be of 5 or 6 digits");
      setRmRequired(false);
    } else if (value.length === 5) {
      setRmError("");
    }
  };

  const handleClientEmailChange = (event) => {
    const value = event.target.value.trim();
    setClientEmail(value);
    setClientEmailError(""); // Clear any previous error



    // Check the email does not contain domains like "@bajajcapital.com", "@bajajcapital.co" or "@bajajcapital.c"
    if (value.toLowerCase().includes('@bajajcapital.c')) {
      setClientEmailError("Emails with @bajajcapital domain are not allowed");
      return;
    }


    // Check if the email is empty
    if (value === "") {
      setClientEmailError("Email is required");
      setClientEmailRequired(false);
      return;
    }

    // Basic email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(value)) {
      setClientEmailError("Please enter a valid email address");
      setClientEmailRequired(false);
    } else {
      setClientEmailError("");
      //setClientEmailRequired(true);
    }
  };

  const handleAssignPlanChange = (event) => {
    const value = event.target.value.trim();
    setAssignPlan(value);
    setassignPlanError(""); // Clear any previous error

    // Check if the email is empty
    if (value === "" || (/^[1-9]\d{0,5}$/.test(value))) {
      setAssignPlan(value);
    }

    // Validate length
    if (value.length >= 1 && value.length !== 5 && value.length !== 6) {
      setassignPlanError("RM code should be of 5 or 6 digits");
      setAssignPlanRequired(false);
      setDisableRm(false);
      setRm('');
    } else if (value.length === 5) {
      setassignPlanError("");
      setRm(localStorage?.getItem('bCode'));
      setDisableRm(true);
    }
  };

  // Age
  const handleAgeChange = (event) => {
    const value = event.target.value;
    if (value == '' || (lifeExpectValue != '' && (Number(lifeExpectValue) < 85 || Number(lifeExpectValue) > 100))) {
      // setLifeExpectValue('')
      setLifeExpectError("Please enter a valid age between 85 and 100.");
    }
    if (value == '' || (YoR != '' && value >= YoR)) {
      // setYoR('')
      setYorError("Please enter a valid age greater than current age and max 75.");
    }

    if (!/^\d{0,2}$/.test(value)) {
      return; // Stop execution if more than 2 digits
    }
    setAge(value);
    if (value && lifeExpectValue == 100 && value < 100) {
      // setLifeExpectValue('')
      setLifeExpectError("");
    }
    // Ensure the input is a number and validate the range
    if ((Number.isInteger(+value) && value >= 18 && value <= 58)) {
      setError(""); // Clear error message
      if (lifeExpectValue !== "" && Number(lifeExpectValue) >= 85 && Number(lifeExpectValue) <= 100) {
        setLifeExpectError("");
      }
      if (value < YoR) {
        setYorError("");
      }


      setAgeRequired(false)

    } else {
      setError("Please enter a valid age greater than or equal to 18 and maximum 58.");
    }
  };
  //Life Expect
  const handleLifeExpectChange = (event) => {
    const value = event.target.value;
    if (!/^\d{0,3}$/.test(value)) {
      return; // Stop execution if input is invalid
    }
    if (Number(value) > 100) {
      return; // Prevent entering values larger than 100
    }
    const numericValue = Number(value)
    if (age && YoR) {
      setLifeExpectValue(value);
      // Ensure the input is a number and validate the range
      if (numericValue >= 85 && numericValue <= 100) {
        setLifeExpectError(""); // Clear error message
        setLifeExpectRequired(false)
      } else {
        setLifeExpectError("Please enter a valid age between 85 and 100.");
      }
    } else {
      setLifeExpectError("Please enter your age and age of retirement first");
    }

  };
  //Age of retirement
  const handleYorChange = (event) => {
    const value = event.target.value;
    if (age && (value == '' || (lifeExpectValue != '' && (Number(lifeExpectValue) < 85 || Number(lifeExpectValue) > 100)))) {
      // setLifeExpectValue('')
      setLifeExpectError("Please enter a valid age between 85 and 100.");
    }
    if (!/^\d{0,2}$/.test(value)) {
      return; // Stop execution if input is invalid
    }
    if (age && value && lifeExpectValue == 100 && value < 100) {
      // setLifeExpectValue('')
      setLifeExpectError("");
    }
    const numericValue = Number(value)
    if (age) {
      setYoR(value);

      // Ensure the input is a number and validate the range
      if ((numericValue >= Number(age) + 1 && numericValue <= 75)) {
        setYorError(""); // Clear error message
        if (lifeExpectValue !== "" && Number(lifeExpectValue) >= 85 && Number(lifeExpectValue) <= 100) {
          setLifeExpectError("");
        }

        setYorRequired(false)
      } else {
        setYorError("Please enter a valid age greater than current age and max 75.");
      }
    } else {
      setYorError("Please enter your age first");
    }
  }
  const handleExpenseChange = (event) => {
    // const inputValue = event.target.value;
    // if (!/^(|[1-9][0-9]{0,5})$/.test(inputValue)) {
    //   return;
    // }
    //     if (inputValue === "") {
    //       setExpenseValue("");
    //       setExpenseError("");
    //       return;
    //     }
    // const numericValue = Number(inputValue);

    // // Set state
    // setExpenseValue(numericValue);

    // // Validate range
    // if (numericValue >= 20000 && numericValue <= 800000) {
    //   setExpenseError(""); // Clear error
    //   setExpenseRequired(false)
    // } else {
    //   setExpenseError("Value must be between 20,000 and 8,00,000.");
    // }
    let inputValue = event.target.value.replace(/,/g, ""); // Remove commas before processing

    if (!/^(|[1-9][0-9]{0,5})$/.test(inputValue)) {
      return;
    }

    if (inputValue === "") {
      setExpenseValue("");
      setNumericExpenseValue(null);
      return;
    }

    const numericValue = Number(inputValue);

    // Format the number with Indian currency format
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Update both states
    setExpenseValue(formattedValue);
    setNumericExpenseValue(numericValue); // Keep a plain number for backend validation

    // Validate range
    if (numericValue >= 20000 && numericValue <= 800000) {
      setExpenseError(""); // Clear error
      setExpenseRequired(false);
    } else {
      setExpenseError("Value must be between 20,000 and 8,00,000.");
    }
  };

  const handleExpenseBlur = (event) => {
    // Adjust value if it's out of range
    let value = event.target.value.replace(/,/g, ""); // Remove commas
    let numericValue = Number(value);

    if (numericValue < 20000) {
      setExpenseValue("20,000");
      setNumericExpenseValue(20000);
      setExpenseError("");
      setExpenseRequired(false);
    } else if (numericValue > 800000) {
      setExpenseValue("8,00,000");
      setNumericExpenseValue(800000);
      setExpenseError("");
      setExpenseRequired(false);
    }
  };
  //annual income
  const handleIncomeChange = (event) => {
    // const inputValue = event.target.value;
    // if (!/^(|[1-9][0-9]{0,5})$/.test(inputValue)) {
    //   return;
    // }
    //     if (inputValue === "") {
    //       setExpenseValue("");
    //       setExpenseError("");
    //       return;
    //     }
    // const numericValue = Number(inputValue);

    // // Set state
    // setExpenseValue(numericValue);

    // // Validate range
    // if (numericValue >= 20000 && numericValue <= 800000) {
    //   setExpenseError(""); // Clear error
    //   setExpenseRequired(false)
    // } else {
    //   setExpenseError("Value must be between 20,000 and 8,00,000.");
    // }
    let inputValue = event.target.value.replace(/,/g, ""); // Remove commas before processing

    if (!/^(|[1-9][0-9]{0,7})$/.test(inputValue)) {
      return;
    }

    if (inputValue === "") {
      setIncomeValue("");
      setNumericIncomeValue(null);
      return;
    }

    const numericValue = Number(inputValue);

    // Format the number with Indian currency format
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Update both states
    setIncomeValue(formattedValue);
    setNumericIncomeValue(numericValue); // Keep a plain number for backend validation

    // Validate range
    if (numericValue >= 300000 && numericValue <= 25000000) {
      setIncomeError(""); // Clear error
      setIncomeRequired(false);
    } else {
      setIncomeError("Value must be between 3,00,000 and 2,50,00,000.");
    }
  };

  const handleIncomeBlur = (event) => {
    // Adjust value if it's out of range
    let value = event.target.value.replace(/,/g, ""); // Remove commas
    let numericValue = Number(value);

    if (numericValue < 300000) {
      setIncomeValue("3,00,000");
      setNumericIncomeValue(300000);
      setIncomeError("");
      setIncomeRequired(false);
    } else if (numericValue > 25000000) {
      setIncomeValue("2,50,00,000");
      setNumericIncomeValue(25000000);
      setIncomeError("");
      setIncomeRequired
    }
  };
  const handleProgressChange = (event) => {
    let value = event.target.value;

    // Allow only numbers with up to 2 digits and an optional single decimal place
    const validPattern = /^(?:\d{1,2}(?:\.\d)?)?$/;

    if (validPattern.test(value)) {
      setProgressValue(parseFloat(value) || ""); // Ensure empty input doesn't become NaN
    }
  };
  const handleInflationBlur = (event) => {
    const value = Math.round((event.target.value) * 2) / 2;
    setProgressValue(value)
    if (value < 3) {
      setProgressValue(3);

    } else if (value > 10) {
      setProgressValue(10);

    }
  }

  const handleNext = async () => {

    //return false;
    try {
      let hasError = false;
      if (clientName == '') {
        // alert('No field should be empty')
        setNameRequired(true)
        setClientError('Name is required')
        hasError = true
      }
      if (phone == '') {
        // alert('No field should be empty')
        setPhoneRequired(true)
        setPhoneError('Phone Number is required')
        hasError = true
      }
      if (age == '') {
        setAgeRequired(true)
        setError('Age is required')
        hasError = true
      }
      if (lifeExpectValue == '') {
        setLifeExpectRequired(true)
        setLifeExpectError('Life expectancy is required')
        hasError = true
      }
      if (expenseValue == '') {
        setExpenseRequired(true)
        setExpenseError('Life expenses is required')
        hasError = true
      }
      if (incomeValue == '') {
        setIncomeRequired(true)
        setIncomeError('Annual Income is required')
        hasError = true
      }
      if (YoR == '') {
        setYorRequired(true)
        setYorError('Year of retirement is required')
        hasError = true
      }
      if (rm == '') {
        setRmRequired(true)
        setRmError('RM Code is required')
        hasError = true
      }
      if (clientEmail == '') {
        setClientEmailRequired(true)
        setClientEmailError('Email is required')
        hasError = true
      }
      if (pan == '') {
        let rm_info = localStorage.getItem('rm_info');
        rm_info = JSON.parse(rm_info);

        if (!(rm_info.BRANCH_NAME.includes('swat') || rm_info.BRANCH_NAME.includes('SWAT') || rm_info.BRANCH_NAME.includes('VIS - NORTH'))) {
          setPanRequired(true)
          setPanError('Pan is required')
          hasError = true
        }

      }

      if (hasError) return;
      if (clientError != '' || phoneError != '' || clientEmailError != '' || error != '' || lifeExpectError != '' || yorError != '' || rmError != '' || panError != '') {
        return
      }
      setLoading(true)
      const localtoken = localStorage?.getItem("ssotoken");
      let category_id = null;
      //

      const data = {
        flagType: "payroll_id",
        payroll_id: rm
      }
      const category = await prpHttpAPI(data, 'rm-info', localtoken, "POST")
      if (category.success) {
        console.log("category is", category);
        category_id = category.data[0].CATEGORY_ID;
        localStorage.setItem('rm_name', category.data[0].EMP_NAME);
        localStorage.setItem('rm_email', category.data[0].EMAIL)
      } else {
        console.log("error in category", category);
        window.toastr.error((category.msg || category.error), 'Error', {
          closeButton: true,
          positionClass: 'toast-top-right',
          // timeOut: 5000, // Auto-close after 5 seconds
        });
        return;
      }


      const savedData = localStorage?.getItem('userData');
      var assignRMExist;
      if (assignPlan) {
        assignRMExist = assignPlan;
      }
      else if (savedData) {
        const userData = JSON.parse(savedData);
        assignRMExist = userData.assign_plan;
      }
      else {
        assignRMExist = null;
      }



      const user = {
        client_name: clientName,
        phone_number: String(phone),
        pan_number: pan,
        spoc_rm: rm,
        age: Number(age),
        year_of_retirement: typeof YoR === "number" ? YoR : Number(YoR),
        life_expectancy: Number(lifeExpectValue),
        monthly_expenses: Number(numericExpenseValue),
        annual_income: Number(numericIncomeValue),
        inflation_rate: parseFloat(String(progressValue)) || progressValue,
        category_id: category_id,
        plan_id: plan_id,
        client_email: clientEmail,
        assign_plan: assignRMExist,
        family_members: familyMembers,                                      //updatedd
        annual_growth_rate: parseInt(String(incomeGrowthRate)),  //updatedd

      }
      setClient(user)
      console.log(user);
      localStorage.setItem('inflationRate', progressValue);
      localStorage.setItem('userData', JSON.stringify(user));
      const result = await prpHttpAPI(user, 'client-details', localtoken, "POST", path)
      console.log("result in clientdetails", result);


      if (result.success) {

        localStorage.setItem("plan_id", result.data.plan_id);
        localStorage.setItem("client_name", result.data.client_name);
        localStorage.setItem('client_age', result.data.age)
        if (result.data.spoc_rm != null) {
          localStorage.setItem("spoc_rm", result.data.spoc_rm);
        } else {
          localStorage.setItem("spoc_rm", result.data.rm_code);
        }
        console.log(result.data.plan_id)
        window.scrollTo({ top: 0, behavior: 'smooth' });
        navigate('/client-investments', { state: { plan_id: result.data.plan_id } })
      } else {

        if (result.status == 403) {

          console.log('OPT needs to verify');
          console.log(window.toastr);

          setShowModal(true);
          const optResult = await prpHttpAPI(user, 'opt/send', localtoken, "POST")
          console.log("otp api result ", optResult);
        }
        else {
          window.toastr.error((result.msg || result.error), 'Error', {
            closeButton: true,
            positionClass: 'toast-top-right',
            // timeOut: 5000, // Auto-close after 5 seconds
          });
        }

      }
    } catch (error) {
      console.log("There is some error after api fetch", error.message);
    } finally {
      setLoading(false)
    }
  }


  return (
    // <>
    //   <div className={styles.topMain}>
    //     <PageTracker currentStep={1} />
    //     <div className={styles.main}>
    //       <div><p className={styles.heading} >Enter <span className={styles.highlighted}>Client Details</span> </p></div>
    //       <div className={styles.searchGroup}>
    //         {/* <div className={styles.toggle}>
    //     <div className={styles.question}>
    //     <p >Existing Client</p></div>
    //     <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
    //        <input type="radio" className="btn-check" name="btnradio" id="btnradio1" disabled   autoComplete="off" defaultChecked={isClientExist}/>
    //        <label onClick={()=>setIsClientExist(true)} className={` btn  ${styles.customBtn}`} htmlFor="btnradio1">Yes</label>

    //        <input type="radio" className="btn-check" name="btnradio" id="btnradio2"  autoComplete="off" defaultChecked={!isClientExist}/>
    //        <label onClick={()=>setIsClientExist(false)} className={` btn  ${styles.customBtn} `} htmlFor="btnradio2">No</label>
    //     </div>
    //   </div> */}
    //         {isClientExist && <div className={styles.dropDownGroup}> <div className={styles.searchDiv}>
    //           <input type="text" className={styles.searchInput} placeholder='Search a client by name or mobile number' />
    //           <span><img className={styles.searchIcon} src={SearchIcon} alt="Search" /></span>
    //         </div>
    //           {/* Dropdown */}
    //           {/* <div className={styles.dropDown}>
    //     <ul>
    //       <li ><span>Simran</span><span>+91 8888777766</span></li>
    //       <li ><span>Simran</span><span>+91 8888777766</span></li>
    //       <li ><span>Simran</span><span>+91 8888777766</span></li>
    //       <li ><span>Simran</span><span>+91 8888777766</span></li>
    //       <li ><span>Simran</span><span>+91 8888777766</span></li>
    //       <li ><span>Simran</span><span>+91 8888777766</span></li>
    //       <li ><span>Simran</span><span>+91 8888777766</span></li>

    //     </ul>
    //    </div> */}
    //         </div>

    //         }
    //       </div>
    //       <div className={styles.mainDiv}>
    //         <div className={styles.leftInputs}>
    //           <label className={styles.labelField} htmlFor="">Name of the client <span className={styles.aestrik}>*</span>
    //             <input className={`${styles.inputField} ${nameRequired ? styles.inputRequired : ""}`} type="text" required value={clientName} onChange={handleClientNameChange} placeholder="Enter client's name" disabled={userReturningFlag} />
    //             {clientError && <p className={styles.error}>{clientError}</p>}
    //           </label>
    //           {/* pan number */}
    //           <label className={styles.labelField} htmlFor="">Pan Number

    //             {!(rmInfo.BRANCH_NAME.includes('swat') || rmInfo.BRANCH_NAME.includes('SWAT') || rmInfo.BRANCH_NAME.includes('VIS - NORTH')) && <span className={styles.aestrik}>*</span>}


    //             <input className={`${styles.inputField} ${panRequired ? styles.inputRequired : ""}`} type="text" disabled={!noPanLength && userReturningFlag && pan?.length == 10} required value={pan} onChange={handlePanChange} placeholder="Enter PAN number" maxLength={10} />
    //             {panError && <p className={styles.error}>{panError}</p>}
    //           </label>
    //           {/* annual income */}
    //           <label className={styles.labelField} htmlFor="">Gross Annual Income <span className={styles.aestrik}>*</span>
    //             <div className={styles.inputDiv}>
    //               {incomeValue && <span className={styles.inputSpanBefore}>₹</span>}
    //               <input className={`${styles.inputField} ${incomeRequired ? styles.inputRequired : ""}`} type="text" value={incomeValue} onChange={handleIncomeChange} onBlur={handleIncomeBlur} min="300000" max="25000000" placeholder="Enter client's annual income" />
    //             </div>
    //             {incomeError && <p className={styles.error}>{incomeError}</p>}
    //           </label>
    //           <label className={styles.labelField} htmlFor="">Monthly expenses needed if client retired today <span className={styles.aestrik}>*</span>
    //             <div className={styles.inputDiv}>
    //               {expenseValue && <span className={styles.inputSpanBefore}>₹</span>}
    //               <input className={`${styles.inputField} ${expenseRequired ? styles.inputRequired : ""}`} type="text" value={expenseValue} onChange={handleExpenseChange} onBlur={handleExpenseBlur} min="20000" max="800000" placeholder="Enter client's monthly expenses if it retires today" />
    //             </div>
    //             {showAssignPlan && (<label className={styles.labelField} htmlFor="">Assigned RM
    //               {/* <span className={styles.aestrik}>*</span> */}
    //               <input className={`${styles.inputField} ${assignPlanRequired ? styles.inputRequired : ""}`} type="text" value={assignPlan} onChange={handleAssignPlanChange} onPaste={handleAssignPlanChange} placeholder="Enter RM code" />
    //               {assignPlanError && <p className={styles.error}>{assignPlanError}</p>}
    //             </label>)}
    //             {expenseError && <p className={styles.error}>{expenseError}</p>}
    //           </label>
    //           <div className={styles.progressText}>
    //             <label className={styles.labelField}>Inflation Rate p.a. <span className={styles.aestrik}>*</span>
    //             </label>
    //             <div className={styles.inflationDiv}>
    //               <input value={progressValue} onChange={handleProgressChange} onBlur={handleInflationBlur} type="number" step={0.5} min={6} max={15} className={styles.inflationRate}></input>
    //               <span className={styles.inflationSpan}>%</span>
    //             </div>
    //           </div>
    //           <div className={styles.progressBar} >

    //             <input
    //               className={styles.inputField}
    //               type="range"
    //               min="3"
    //               max="10"
    //               step="0.5"
    //               value={progressValue}
    //               onChange={handleProgressChange}
    //             />
    //           </div>
    //           <div className={styles.progressLimit}>
    //             <span>3%</span>
    //             <span>10%</span>
    //           </div>

    //         </div>

    //         <div className={styles.rightInputs}>
    //           <label className={styles.labelField} htmlFor="">Phone Number <span className={styles.aestrik}>*</span>
    //             <div className={styles.phoneGroup}>
    //               <span>+91</span>
    //               <input className={`${styles.inputField} ${styles.phoneNumber} ${phoneRequired ? styles.inputRequired : ""}`} type="text" disabled={userReturningFlag} required value={phone} onChange={handlePhoneChange} onBlur={handlePhoneBlur} placeholder="Enter phone number" maxLength={10} />
    //             </div>
    //             {phoneError && <p className={styles.error}>{phoneError}</p>}        </label>
    //           {/* age  */}
    //           <label className={styles.labelField} htmlFor="">Age <span className={styles.aestrik}>*</span>
    //             <input className={`${styles.inputField} ${ageRequired ? styles.inputRequired : ""}`} type="number" min="18" max="75" step="1" value={age} onChange={handleAgeChange} placeholder="Enter client's age" />
    //             {error && <p className={styles.error}>{error}</p>}
    //           </label>

    //           {/* age of retirement */}
    //           <label className={styles.labelField} htmlFor="">Age of retirement <span className={styles.aestrik}>*</span>
    //             <input className={`${styles.inputField} ${yorRequired ? styles.inputRequired : ""}`} type="number" min={age + 1} max="75" step="1" value={YoR} onChange={handleYorChange} placeholder="Enter retirement age" />
    //             {yorError && <p className={styles.error}>{yorError}</p>}
    //           </label>
    //           <label className={styles.labelField} htmlFor="">Life Expectancy <span className={styles.aestrik}>*</span>
    //             <input className={`${styles.inputField} ${lifeExpectRequired ? styles.inputRequired : ""}`} type="number" min={age + 1} max="100" step="1" value={lifeExpectValue} onChange={handleLifeExpectChange} placeholder="Enter client's life expectancy" />
    //             {lifeExpectError && <p className={styles.error}>{lifeExpectError}</p>}
    //           </label>
    //           {<label className={styles.labelField} htmlFor="">RM Code
    //             <span className={styles.aestrik}>*</span>
    //             <input className={`${styles.inputField} ${rmRequired ? styles.inputRequired : ""}`} type="text" value={rm} onChange={handleRmChange} placeholder="Enter RM code" maxLength={6} disabled={disableRm} />
    //             {rmError && <p className={styles.error}>{rmError}</p>}
    //           </label>}

    //           {<label className={styles.labelField} htmlFor="">Email
    //             <span className={styles.aestrik}>*</span>
    //             <input className={`${styles.inputField} ${clientEmailRequired ? styles.inputRequired : ""}`} type="text" value={clientEmail} onChange={handleClientEmailChange} required placeholder="Enter Email" />
    //             {clientEmailError && <p className={styles.error}>{clientEmailError}</p>}
    //           </label>}



    //           {/* <label className={styles.labelField} htmlFor="">Age of retirement <span className={styles.aestrik}>*</span>
    //      <div className={styles.yearDiv}>
    //     <YearPicker onYearChange={(year) => setYoR(year) }  YoR={YoR} setYorError={setYorError} yorRequired={yorRequired} setYorRequired={setYorRequired} />
    //      <img className={styles.yearIcon} src={YearIcon} alt="Year" />

    //      </div>
    //      {yorError && <p className={styles.error}>{yorError}</p>}
    //     </label> */}



    //         </div>

    //       </div>
    //       <div className={styles.buttonLoader}>
    //         <button onClick={handleNext} className={` btn  ${styles.nextBtn}`} disabled={(rMMessage.length > 0 || nextDisable == true || !!clientEmailError) ? true : false}>Next</button>
    //         {loading &&
    //           <div className={` spinner-border text-danger ${styles.loaderDiv}`} role="status">
    //             <span className="sr-only"></span>
    //           </div>}


    //       </div>
    //     </div>
    //   </div>
    //   {showModal && <Otp setShowModal={setShowModal} flag={true} name="OTP" number={phone} tokan={localtoken} nextH={handleNext} />}
    // </>  old html

    <>
      <div className={styles.topMain}>
        <PageTracker currentStep={1} />
        <div className={styles.main}>
          {rMMessage && (
            <div className={`${styles.alertBox} ${styles.alertError}`}>
              <span className={`material-symbols-outlined ${styles.alertIcon}`}>warning</span>
              <p className={styles.alertText}>{rMMessage}</p>
            </div>
          )}



          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.redLine}></div>
              <p className={styles.heading}>Client Details</p>
            </div>

            <div className={styles.gridContainer}>
              {/* Row 1 */}
              <label className={styles.labelField}>
                Name of Client <span className={styles.aestrik}>*</span>
                <input className={`${styles.inputField} ${nameRequired ? styles.inputRequired : ""}`} type="text" required value={clientName} onChange={handleClientNameChange} placeholder="Enter client's full name" disabled={userReturningFlag} />
                {clientError && <p className={styles.error}>{clientError}</p>}
              </label>

              <label className={styles.labelField}>
                Phone Number <span className={styles.aestrik}>*</span>
                <div className={styles.phoneGroup}>
                  <span>+91</span>
                  <input className={`${styles.inputField} ${styles.phoneNumber} ${phoneRequired ? styles.inputRequired : ""}`} type="text" disabled={userReturningFlag} required value={phone} onChange={handlePhoneChange} onBlur={handlePhoneBlur} placeholder="XXXXX XXXXX" maxLength={10} />
                </div>
                {phoneError && <p className={styles.error}>{phoneError}</p>}
              </label>

              {/* Row 2 */}
              <label className={styles.labelField}>
                Email <span className={styles.aestrik}>*</span>
                <input className={`${styles.inputField} ${clientEmailRequired ? styles.inputRequired : ""}`} type="text" value={clientEmail} onChange={handleClientEmailChange} required placeholder="client@email.com" />
                {clientEmailError && <p className={styles.error}>{clientEmailError}</p>}
              </label>

              <label className={styles.labelField}>
                Client PAN
                {!(rmInfo.BRANCH_NAME.includes('swat') || rmInfo.BRANCH_NAME.includes('SWAT') || rmInfo.BRANCH_NAME.includes('VIS - NORTH')) && <span className={styles.aestrik}>*</span>}
                <input className={`${styles.inputField} ${panRequired ? styles.inputRequired : ""}`} type="text" disabled={!noPanLength && userReturningFlag && pan?.length == 10} required value={pan ?? ""} onChange={handlePanChange} placeholder="ABCDE1234F" maxLength={10} />
                {panError && <p className={styles.error}>{panError}</p>}
              </label>

              {/* Row 3 */}
              <label className={styles.labelField}>
                Age <span className={styles.aestrik}>*</span>
                <input className={`${styles.inputField} ${ageRequired ? styles.inputRequired : ""}`} type="number" min="18" max="75" step="1" value={age} onChange={handleAgeChange} placeholder="e.g. 40" />
                {error && <p className={styles.error}>{error}</p>}
              </label>

              <label className={styles.labelField}>
                Age of Retirement <span className={styles.aestrik}>*</span>
                <input className={`${styles.inputField} ${yorRequired ? styles.inputRequired : ""}`} type="number" min={age + 1} max="75" step="1" value={YoR} onChange={handleYorChange} placeholder="e.g. 55" />
                {yorError && <p className={styles.error}>{yorError}</p>}
              </label>

              {/* Row 4 */}
              <label className={styles.labelField}>
                Gross Annual Income <span className={styles.aestrik}>*</span>
                <div className={styles.inputDiv}>
                  {incomeValue && <span className={styles.inputSpanBefore}>₹</span>}
                  <input className={`${styles.inputField} ${incomeRequired ? styles.inputRequired : ""}`} type="text" value={incomeValue} onChange={handleIncomeChange} onBlur={handleIncomeBlur} placeholder="e.g. 15,00,000" />
                </div>
                {incomeError && <p className={styles.error}>{incomeError}</p>}
              </label>

              <label className={styles.labelField}>
                Monthly Expenses (if retired today) <span className={styles.aestrik}>*</span>
                <div className={styles.inputDiv}>
                  {expenseValue && <span className={styles.inputSpanBefore}>₹</span>}
                  <input className={`${styles.inputField} ${expenseRequired ? styles.inputRequired : ""}`} type="text" value={expenseValue} onChange={handleExpenseChange} onBlur={handleExpenseBlur} placeholder="e.g. 1,00,000" />
                </div>
                {expenseError && <p className={styles.error}>{expenseError}</p>}
              </label>

              {/* Row 5 */}
              <label className={styles.labelField}>
                Life Expectancy <span className={styles.aestrik}>*</span>
                <input className={`${styles.inputField} ${lifeExpectRequired ? styles.inputRequired : ""}`} type="number" min="85" max="100" step="1" value={lifeExpectValue} onChange={handleLifeExpectChange} placeholder="e.g. 85" />
                {lifeExpectError && <p className={styles.error}>{lifeExpectError}</p>}
              </label>

              <label className={styles.labelField}>
                RM Business Code <span className={styles.aestrik}>*</span>
                <input className={`${styles.inputField} ${rmRequired ? styles.inputRequired : ""}`} type="text" value={rm ?? ""} onChange={handleRmChange} placeholder="RM Code" maxLength={6} disabled={disableRm} />
                {rmError && <p className={styles.error}>{rmError}</p>}
              </label>

              {/* Row 6 */}
              <label className={styles.labelField}>
                Annual Income Growth Rate <span className={styles.aestrik}>*</span>
                <select className={styles.inputField} value={incomeGrowthRate} onChange={(e) => setIncomeGrowthRate(e.target.value)}>
                  <option value="0% — Fixed Income">0%</option>
                  <option value="1%">1%</option>
                  <option value="2%">2%</option>
                  <option value="3%">3%</option>
                  <option value="4%">4%</option>
                  <option value="5%">5%</option>
                  <option value="6%">6%</option>
                  <option value="7%">7%</option>
                  <option value="8%">8%</option>
                  <option value="9%">9%</option>
                  <option value="10%">10%</option>
                  <option value="11%">11%</option>
                  <option value="12%">12%</option>
                  <option value="13%">13%</option>
                  <option value="14%">14%</option>
                  <option value="15%">15%</option>
                </select>
              </label>

              <label className={styles.labelField}>
                Inflation Rate p.a. <span className={styles.aestrik}>*</span>
                <select className={styles.inputField} value={progressValue} onChange={(e) => setProgressValue(e.target.value)}>
                  <option value="3%">3%</option>
                  <option value="4%">4%</option>
                  <option value="5%">5%</option>
                  <option value="6%">6%</option>
                  <option value="7%">7%</option>
                  <option value="8%">8%</option>
                  <option value="9%">9%</option>
                  <option value="10%">10%</option>
                  <option value="11%">11%</option>
                  <option value="12%">12%</option>
                  <option value="13%">13%</option>
                  <option value="14%">14%</option>
                  <option value="15%">15%</option>
                </select>
              </label>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.redLine}></div>
              <p className={styles.heading}>Family Members PAN <span className={styles.optionalBadge}>Optional</span></p>
            </div>
            <p className={styles.subHeading}>Add PAN for spouse, children or other family members linked to this plan.</p>

            <div className={styles.familyMembersList}>
              {familyMembers.map((member, index) => (
                <div key={index} className={styles.familyMemberRow}>
                  <input
                    className={styles.inputField}
                    type="text"
                    value={member.name}
                    onChange={(e) => handleFamilyMemberChange(index, 'name', e.target.value)}
                    placeholder="Name"
                  />
                  <select
                    className={styles.inputField}
                    value={member.relationship}
                    onChange={(e) => handleFamilyMemberChange(index, 'relationship', e.target.value)}
                  >
                    <option value="Spouse">Spouse</option>
                    <option value="Child">Child</option>
                    <option value="Parent">Parent</option>
                    <option value="Other">Other</option>
                  </select>
                  <input
                    className={styles.inputField}
                    type="text"
                    value={member.pan}
                    onChange={(e) => handleFamilyMemberChange(index, 'pan', e.target.value)}
                    placeholder="PAN"
                    maxLength={10}
                  />
                  <button className={styles.removeBtn} onClick={() => handleRemoveFamilyMember(index)}>×</button>
                </div>
              ))}
            </div>

            <button className={styles.addFamilyBtn} onClick={handleAddFamilyMember}>
              + Add Family Member
            </button>
          </div>

          <div className={styles.loaderGroup}>
            <button onClick={handleNext} className={` btn  ${styles.nextBtn}`} disabled={(rMMessage.length > 0 || nextDisable == true || !!clientEmailError || loading) ? true : false}>
              Next — Investments <span className={styles.arrow}>→</span>
            </button>
            <div className={styles.loaderContainer}>
              {loading && (
                <div className={`spinner-border spinner-border-sm text-danger`} role="status">
                  <span className="sr-only"></span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModal && <Otp setShowModal={setShowModal} flag={true} name="OTP" number={phone} tokan={localtoken} nextH={handleNext} />}

    </>   //new html 
  )
}

export default ClientDetails